module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pop-window', {
    attrs: {
      "visible": _vm.value,
      "position": _vm.position,
      "zIndex": _vm.zIndex
    },
    on: {
      "onBackgroundClick": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "resourcs-window",
    style: (_vm.windowStyle)
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title-box"
  }, [(_vm.title) ? _c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("header")], 2), _c('el-button', {
    staticClass: "btn close-btn",
    on: {
      "click": _vm.onClose
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])], 1), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b1ab9a3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Window.vue
// module id = 574
// module chunks = 85